import React, {Fragment, useEffect, useRef, useState} from "react";
import * as ReactDOM from 'react-dom';
import {Badge, Button, Card, CardBody, Col, FormGroup, Input, Label} from "reactstrap";
import Select from "react-select";
import JqxTable from "../../../../share-components/table/JqxTable";
import {toast} from "react-toastify";
import ButtonLoader from "../../../../share-components/ui/buttonLoader";
import {useDispatch, useSelector} from "react-redux";
import {updateInventory} from "../../store/inventorySlice";


const VariationInventoryJqx = (props) => {
    const {productId, sizes, variants, isThirdPartySeller} = props;
    const dispatch = useDispatch();
    let gridRef = useRef();
    let selectRef = useRef(null);
    const [variationData, setVariationData] = useState([]);
    const [buttonDisable, setButtonDisable] = useState(false);
    const currentUser = useSelector(({authReducer}) => authReducer.data.user);
    const hasEditPermission = (currentUser.permission).includes('Edit Inventory') && isThirdPartySeller;
    const hasHistoryPermission = (currentUser.permission).includes('Inventory');
    //const roleRegister = register("role", { required: true });
    let datafields = [
        {name: 'id', type: 'id'},
        {name: 'colour_id', type: 'id'},
        {name: 'colour_name', type: 'string'},
        {name:'pack_for_single',type: 'number'}

    ];

    let columns = [
        {datafield: 'id', hidden: true},
        {datafield: 'colour_id', hidden: true},
        {datafield: 'pack_for_single', hidden: true},
        {
            text: 'Colour',
            datafield: 'colour_name',
            editable: false,
            columntype: 'text',
            width: '50%'

        }];

    sizes.map((item, key) => {
        datafields.push({
            name: item.id,
            type: 'string'
        });
        datafields.push({
            name: 'product_variant_id_' + item.id,
            type: 'number'
        });
        datafields.push({
            name: 'sku_' + item.id,
            type: 'string'
        });
        columns.push({
            text: item.name,
            datafield: item.id,
            width: (50 / sizes.length) + '%',
            editable: hasEditPermission,
            columntype: 'text',
            cellsrenderer: (row, columnfield, value, defaulthtml, columnproperties, rowdata) => {
                const variantId = rowdata ? rowdata['product_variant_id_' + item.id] : null;
                const sku = rowdata ? rowdata['sku_' + item.id] : null;
                if (!hasHistoryPermission || !variantId || !sku) {
                    return defaulthtml;
                }
                return '<div class="jqx-inventory-cell" style="padding:10px 8px;">' +
                    '<span>' + (value !== undefined && value !== null ? value : '') + '</span>' +
                    '<a class="jqx-view-history-icon" data-sku="' + sku + '" data-variant-id="' + variantId + '" title="View history">' +
                    '<i class="fa fa-history" style="margin-left:6px;color:#7366FF;cursor:pointer;"></i>' +
                    '</a>' +
                    '</div>';
            },
        })
    });

    useEffect(() => {
        setVariationData(variants);
    }, [variants]);

    useEffect(() => {
        if (!hasHistoryPermission) return;

        let container = null;
        const handleClick = (event) => {
            const icon = event.target.closest('.jqx-view-history-icon');
            if (!icon) return;
            event.stopPropagation();
            const sku = icon.getAttribute('data-sku');
            const variantId = icon.getAttribute('data-variant-id');
            if (sku && variantId) {
                window.open(
                    `${process.env.PUBLIC_URL}/product/inventory-history-details?sku=` + encodeURIComponent(sku) + '&product_variant_id=' + encodeURIComponent(variantId),
                    '_blank',
                    'noopener,noreferrer'
                );
            }
        };

        const timeoutId = setTimeout(() => {
            if (gridRef && gridRef._id) {
                container = document.getElementById(gridRef._id);
                if (container) {
                    container.addEventListener('click', handleClick);
                }
            }
        }, 1000);

        return () => {
            clearTimeout(timeoutId);
            if (container) {
                container.removeEventListener('click', handleClick);
            }
        };
    }, [variationData, hasHistoryPermission])

    const getJqxRef = jqx => {
        if (jqx) {
            gridRef = jqx;

            setTimeout(
                () => {
                    if (gridRef) {
                        const myEle = document.getElementById(gridRef._id);
                        if (myEle) {
                            gridRef.updatebounddata();
                        }
                    }

                    // myGrid.updatebounddata();
                },
                1000
            );
        }
    };


    const cellEdit = event => {
        // setDataToHookForm();
        if (event.args.datafield == 'name') {
            // trigger('color');
        }
    };
    const inventoryUpdateSubmit = () => {
        const data = setDataToHookForm();
        setButtonDisable(true);
        const params = {id: productId, variation: {variation: data}};

        dispatch(updateInventory({...params}))
            .unwrap()
            .then(() => {
                setButtonDisable(false);
            })
            .catch(() => {
                setButtonDisable(false);
            });
    }


    const setDataToHookForm = () => {

        let variantData = [];
        const gridInformation = gridRef.getdatainformation();
        for (let i = 0; i < gridInformation.rowscount; i++) {
            const rowData = gridRef.getrowdata(i);
                variantData.push(rowData);

        }
        setVariationData(variantData);
        return variantData;

    }


    return (
        <Fragment>
            {variationData.length >0 &&   <>
                <div className="form-row mb-3">
                    <Col md="12">
                        <div style={{width: '100%'}}>
                            <JqxTable
                                datafields={datafields}
                                columns={columns}
                                data={variationData}
                                myGrid={gridRef}
                                getJqxRef={getJqxRef}
                                isDelete={false}
                                onCellendedit={cellEdit}
                                disableCreateRow
                            />
                        </div>
                    </Col>
                </div>
                {(currentUser.permission).includes('Create Inventory Item') ?
                <div className="form-row mb-3">
                    <Col md="12">
                        <ButtonLoader className={'pull-right'} disabled={buttonDisable}  onClick={inventoryUpdateSubmit} color="primary"  	type="button"  btntext="Save & Publish"></ButtonLoader>

                    </Col>
                </div>
                    :''}
            </>}
        </Fragment>
    );
}
// function areEqual(prevProps, nextProps) {
//     return JSON.stringify(prevProps.getValues) == JSON.stringify(nextProps.getValues);
//     /*
//     return true if passing nextProps to render would return
//     the same result as passing prevProps to render,
//     otherwise return false
//     */
// }
export default VariationInventoryJqx;